import appStore from 'store';
import api from './api';
import { PAGINATION } from './constants';

const store = {
  namespaced: true,
  state: {
    tradePairList: [],
    pagination: PAGINATION,
    totalCount: 0
  },
  getters: {},
  mutations: {
    setTradePairList(state, payload) {
      state.tradePairList = payload.list;
      state.totalCount = payload.totalCount;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    },
    setTradeArea(state, payload) {
      state.tradeArea = payload;
    }
  },
  actions: {
    list({ commit }, data) {
      api.getTradePairList(data).then(({ data }) => {
        commit('setTradePairList', data);
      });
    },

    createand(context, data) {
      return api.createand(data);
    },
    creatios(context, data) {
      return api.creatios(data);
    }
  }
};

appStore.registerModule('pushsetting', store);
